"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2334],{

/***/ 31796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ instanceOfIMediaItem; }
/* harmony export */ });
var instanceOfIMediaItem = function(object) {
    return "file" in object && "meta" in object;
};


/***/ }),

/***/ 48493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sn": function() { return /* binding */ uploadMetadata; },
/* harmony export */   "cT": function() { return /* binding */ uploadFile; },
/* harmony export */   "uj": function() { return /* binding */ uploadAssets; }
/* harmony export */ });
/* unused harmony export pinObject */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var buffer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48764);
/* harmony import */ var read_json_lines_sync__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52651);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);
/* harmony import */ var _interface_media__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31796);
/* harmony import */ var _ipld_dag_pb__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81972);
/* harmony import */ var _utils_tzip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17874);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70409);





/* eslint-disable no-console */ /* eslint-disable no-await-in-loop */ 






var REQUEST_TRIES = 2;
var RATE_LIMIT_SLEEP = 30000;
function rateLimitGuard(exec) {
    return _rateLimitGuard.apply(this, arguments);
}
function _rateLimitGuard() {
    _rateLimitGuard = // wrapper function that retries API call if it gets a 429 error
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(exec) {
        var count, res, text;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    count = 0;
                case 1:
                    if (!(count < REQUEST_TRIES)) {
                        _ctx.next = 23;
                        break;
                    }
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return exec();
                case 5:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    text = _ctx.t0.message;
                    if (!(text === "Too Many Requests")) {
                        _ctx.next = 20;
                        break;
                    }
                    count += 1;
                    if (!(count > REQUEST_TRIES)) {
                        _ctx.next = 16;
                        break;
                    }
                    throw _ctx.t0;
                case 16:
                    _ctx.next = 18;
                    return new Promise(function(resolve) {
                        setTimeout(resolve, RATE_LIMIT_SLEEP);
                    });
                case 18:
                    _ctx.next = 21;
                    break;
                case 20:
                    throw _ctx.t0;
                case 21:
                    _ctx.next = 1;
                    break;
                case 23:
                    throw new Error("Request failed");
                case 24:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return _rateLimitGuard.apply(this, arguments);
}
// pin a file or directory
function pinObject(hash) {
    return _pinObject.apply(this, arguments);
}
function _pinObject() {
    _pinObject = _async_to_generator(regeneratorRuntime.mark(function _callee(hash) {
        var authenticated, url, res, result, _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authenticated = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                    url = "".concat(INFURA_URL, "/api/v0/pin/add?arg=").concat(hash);
                    _ctx.next = 4;
                    return fetch(url, {
                        method: "POST",
                        headers: authenticated ? {
                            Authorization: "Basic ".concat("MjRvd0lJdlRONW5jSzY2SFNnckQ2MUtDZWRkOmJjNTQzMjhhNTE4OTM2MWU4N2NkYTgxYzdmODNhYTdj")
                        } : {}
                    });
                case 4:
                    res = _ctx.sent;
                    if (res.ok) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(res.statusText);
                case 7:
                    _ctx.next = 9;
                    return res.json();
                case 9:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _pinObject.apply(this, arguments);
}
// upload single file
function uploadFile(file, pin) {
    return _uploadFile.apply(this, arguments);
}
function _uploadFile() {
    _uploadFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, pin) {
        var authenticated, formData, url, res, Hash, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authenticated = _args.length > 2 && _args[2] !== void 0 ? _args[2] : true;
                    formData = new FormData();
                    formData.append("path", file);
                    url = "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_URL */ .aw, "/api/v0/add?pin=").concat(pin);
                    _ctx.next = 6;
                    return fetch(url, {
                        method: "POST",
                        headers: authenticated ? {
                            Authorization: "Basic ".concat("MjRvd0lJdlRONW5jSzY2SFNnckQ2MUtDZWRkOmJjNTQzMjhhNTE4OTM2MWU4N2NkYTgxYzdmODNhYTdj")
                        } : {},
                        body: formData
                    });
                case 6:
                    res = _ctx.sent;
                    if (res.ok) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(res.statusText);
                case 9:
                    _ctx.next = 11;
                    return res.json();
                case 11:
                    Hash = _ctx.sent.Hash;
                    return _ctx.abrupt("return", Hash);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _uploadFile.apply(this, arguments);
}
function uploadDagNode(node, pin) {
    return _uploadDagNode.apply(this, arguments);
}
function _uploadDagNode() {
    _uploadDagNode = // upload DAG node object
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(node, pin) {
        var authenticated, file, formData, url, res, json, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authenticated = _args.length > 2 && _args[2] !== void 0 ? _args[2] : true;
                    file = new File([
                        (0,_ipld_dag_pb__WEBPACK_IMPORTED_MODULE_4__.encode)(node)
                    ], "", {
                        type: "application/octet-stream"
                    });
                    formData = new FormData();
                    formData.append("data", file);
                    url = "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_URL */ .aw, "/api/v0/dag/put?input-codec=dag-pb&store-codec=dag-pb&pin=").concat(pin);
                    _ctx.next = 7;
                    return fetch(url, {
                        method: "POST",
                        headers: authenticated ? {
                            Authorization: "Basic ".concat("MjRvd0lJdlRONW5jSzY2SFNnckQ2MUtDZWRkOmJjNTQzMjhhNTE4OTM2MWU4N2NkYTgxYzdmODNhYTdj")
                        } : {},
                        body: formData
                    });
                case 7:
                    res = _ctx.sent;
                    if (res.ok) {
                        _ctx.next = 10;
                        break;
                    }
                    throw new Error(res.statusText);
                case 10:
                    _ctx.next = 12;
                    return res.json();
                case 12:
                    json = _ctx.sent;
                    return _ctx.abrupt("return", json.Cid["/"]);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _uploadDagNode.apply(this, arguments);
}
function uploadDirectory(files, directoryName, pin) {
    return _uploadDirectory.apply(this, arguments);
}
function _uploadDirectory() {
    _uploadDirectory = // upload directory
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(files, directoryName, pin) {
        var authenticated, formData, key, url, res, data, rootDir, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authenticated = _args.length > 3 && _args[3] !== void 0 ? _args[3] : true;
                    formData = new FormData();
                    // eslint-disable-next-line no-restricted-syntax
                    for(key in files){
                        if (files[key].type !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .MimeType.WEB */ .HY.WEB) {
                            formData.append("file", files[key], encodeURIComponent(key));
                        }
                    }
                    url = "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_URL */ .aw, "/api/v0/add?recursive=true&wrap-with-directory=true&pin=").concat(pin);
                    _ctx.next = 6;
                    return fetch(url, {
                        method: "POST",
                        headers: authenticated ? {
                            Authorization: "Basic ".concat("MjRvd0lJdlRONW5jSzY2SFNnckQ2MUtDZWRkOmJjNTQzMjhhNTE4OTM2MWU4N2NkYTgxYzdmODNhYTdj")
                        } : {},
                        body: formData
                    });
                case 6:
                    res = _ctx.sent;
                    if (res.ok) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(res.statusText);
                case 9:
                    _ctx.t0 = read_json_lines_sync__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
                    _ctx.next = 12;
                    return res.text();
                case 12:
                    _ctx.t1 = _ctx.sent;
                    data = (0, _ctx.t0)(_ctx.t1);
                    rootDir = data.find(function(e) {
                        return e.Name === "";
                    });
                    return _ctx.abrupt("return", {
                        name: directoryName,
                        hash: rootDir.Hash,
                        size: parseInt(rootDir.Size, 10)
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _uploadDirectory.apply(this, arguments);
}
// create and validate protobuf dag node
var createDirectoryNode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(items) {
        var obj;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    obj = {
                        Data: "\b\x01",
                        Links: items
                    };
                    return _ctx.abrupt("return", (0,_ipld_dag_pb__WEBPACK_IMPORTED_MODULE_4__.prepare)(obj));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createDirectoryNode(items) {
        return _ref.apply(this, arguments);
    };
}();
// upload all assets as directory
var uploadAssets = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(original, media, license) {
        var mediaFiles, originalHash, originalFormat, ref, ref1, ref2, ref3, name, size, hash, mediaHashes, i, hash1, mediaFormats, i1, _i, file, meta, format, mediaItems, mediaNode, mediaCid, mediaCumulativeSize, rootItems, licenseHash, rootNode, rootCid;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    mediaFiles = media.map(function(e) {
                        return e.file;
                    });
                    ;
                    ;
                    if (!(0,_interface_media__WEBPACK_IMPORTED_MODULE_8__/* .instanceOfIMediaItem */ .W)(original)) {
                        _ctx.next = 12;
                        break;
                    }
                    _ctx.next = 6;
                    return rateLimitGuard(function() {
                        return uploadFile(original.file, true, _config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_AUTHENTICATED */ .GB);
                    });
                case 6:
                    // handle individual file
                    originalHash = _ctx.sent;
                    _ctx.next = 9;
                    return (0,_utils_tzip__WEBPACK_IMPORTED_MODULE_5__/* .getTZIPFormat */ .RY)(original.file, originalHash, original.meta);
                case 9:
                    originalFormat = _ctx.sent;
                    _ctx.next = 23;
                    break;
                case 12:
                    ;
                    _ctx.next = 15;
                    return rateLimitGuard(function() {
                        return uploadDirectory(original.files, "original", true, _config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_AUTHENTICATED */ .GB);
                    });
                case 15:
                    ref3 = _ctx.sent;
                    name = ref3.name;
                    size = ref3.size;
                    hash = ref3.hash;
                    originalHash = hash;
                    _ctx.next = 22;
                    return (0,_utils_tzip__WEBPACK_IMPORTED_MODULE_5__/* .getTZIP21WebFormat */ .i0)(hash, name, size, (ref = original.meta) === null || ref === void 0 ? void 0 : ref.width, (ref1 = original.meta) === null || ref1 === void 0 ? void 0 : ref1.height, (ref2 = original.meta) === null || ref2 === void 0 ? void 0 : ref2.aspect);
                case 22:
                    originalFormat = _ctx.sent;
                case 23:
                    mediaHashes = [];
                    i = 0;
                case 25:
                    if (!(i < media.length)) {
                        _ctx.next = 33;
                        break;
                    }
                    _ctx.next = 28;
                    return rateLimitGuard(function() {
                        return uploadFile(media[i].file, true, _config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_AUTHENTICATED */ .GB);
                    });
                case 28:
                    hash1 = _ctx.sent;
                    mediaHashes.push(hash1);
                case 30:
                    i += 1;
                    _ctx.next = 25;
                    break;
                case 33:
                    mediaFormats = [];
                    i1 = 0;
                case 35:
                    if (!(i1 < media.length)) {
                        _ctx.next = 44;
                        break;
                    }
                    _i = media[i1], file = _i.file, meta = _i.meta;
                    _ctx.next = 39;
                    return (0,_utils_tzip__WEBPACK_IMPORTED_MODULE_5__/* .getTZIPFormat */ .RY)(file, mediaHashes[i1], meta);
                case 39:
                    format = _ctx.sent;
                    mediaFormats.push(format);
                case 41:
                    i1 += 1;
                    _ctx.next = 35;
                    break;
                case 44:
                    mediaItems = mediaFiles.map(function(file, index) {
                        return {
                            Name: file.name,
                            Hash: mediaHashes[index],
                            Size: file.size
                        };
                    });
                    _ctx.next = 47;
                    return createDirectoryNode(mediaItems);
                case 47:
                    mediaNode = _ctx.sent;
                    _ctx.next = 50;
                    return rateLimitGuard(function() {
                        return uploadDagNode(mediaNode, true, _config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_AUTHENTICATED */ .GB);
                    });
                case 50:
                    mediaCid = _ctx.sent;
                    mediaCumulativeSize = mediaFiles.reduce(function(total, file) {
                        return total + file.size;
                    }, 0);
                    rootItems = [
                        {
                            Name: originalFormat.fileName,
                            Hash: originalHash,
                            Size: originalFormat.fileSize
                        },
                        {
                            Name: "media",
                            Hash: mediaCid,
                            Size: mediaCumulativeSize
                        }, 
                    ];
                    ;
                    if (!license) {
                        _ctx.next = 59;
                        break;
                    }
                    _ctx.next = 57;
                    return rateLimitGuard(function() {
                        return uploadFile(license, true, _config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_AUTHENTICATED */ .GB);
                    });
                case 57:
                    licenseHash = _ctx.sent;
                    rootItems.push({
                        Name: license.name,
                        Hash: licenseHash,
                        Size: license.size
                    });
                case 59:
                    _ctx.next = 61;
                    return createDirectoryNode(rootItems);
                case 61:
                    rootNode = _ctx.sent;
                    _ctx.next = 64;
                    return rateLimitGuard(function() {
                        return uploadDagNode(rootNode, true, _config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_AUTHENTICATED */ .GB);
                    });
                case 64:
                    rootCid = _ctx.sent;
                    return _ctx.abrupt("return", {
                        pinHash: rootCid.toString(),
                        licenseHash: licenseHash,
                        formats: [
                            originalFormat
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(mediaFormats))
                    });
                case 66:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function uploadAssets(original, media, license) {
        return _ref.apply(this, arguments);
    };
}();
var uploadMetadata = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var name, description, creators, type, tags, rights, rightUri, artifactUri, displayUri, thumbnailUri, pinUri, formats, accessibility, buffer, file, hash;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    name = param.name, description = param.description, creators = param.creators, type = param.type, tags = param.tags, rights = param.rights, rightUri = param.rightUri, artifactUri = param.artifactUri, displayUri = param.displayUri, thumbnailUri = param.thumbnailUri, pinUri = param.pinUri, formats = param.formats, accessibility = param.accessibility;
                    buffer = buffer__WEBPACK_IMPORTED_MODULE_1__.Buffer.from(JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                        decimals: 0,
                        shouldPreferSymbol: false,
                        isBooleanAmount: false,
                        symbol: "ITEM",
                        name: name,
                        description: description,
                        creators: creators,
                        type: type,
                        tags: tags,
                        language: "en",
                        rights: rights
                    }, rightUri && {
                        rightUri: rightUri
                    }), {
                        artifactUri: artifactUri,
                        displayUri: displayUri,
                        thumbnailUri: thumbnailUri,
                        pinUri: pinUri,
                        formats: formats,
                        accessibility: accessibility
                    })));
                    file = new File([
                        buffer
                    ], "metadata.json", {
                        type: "application/json"
                    });
                    _ctx.next = 5;
                    return rateLimitGuard(function() {
                        return uploadFile(file, true, _config__WEBPACK_IMPORTED_MODULE_6__/* .INFURA_AUTHENTICATED */ .GB);
                    });
                case 5:
                    hash = _ctx.sent;
                    return _ctx.abrupt("return", hash);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function uploadMetadata(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 70409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ INFURA_AUTHENTICATED; },
/* harmony export */   "Zh": function() { return /* binding */ UploadProviders; },
/* harmony export */   "aw": function() { return /* binding */ INFURA_URL; },
/* harmony export */   "jH": function() { return /* binding */ NFT_STORAGE_API_TOKEN; },
/* harmony export */   "od": function() { return /* binding */ UPLOAD_PROVIDER; }
/* harmony export */ });
var UploadProviders;
(function(UploadProviders) {
    UploadProviders["NFT_STORAGE"] = "nft.storage";
    UploadProviders["INFURA"] = "infura";
})(UploadProviders || (UploadProviders = {}));
var UPLOAD_PROVIDER = UploadProviders.INFURA;
// NFT Storage
var NFT_STORAGE_API_TOKEN = "missing generated api token";
// Infura
var INFURA_URL = "https://ipfs.infura.io:5001";
var INFURA_AUTHENTICATED = false;


/***/ }),

/***/ 38208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_c": function() { return /* binding */ canvasToBlob; },
/* harmony export */   "m4": function() { return /* binding */ getCroppedImg; },
/* harmony export */   "oL": function() { return /* binding */ isTransparentPNG; }
/* harmony export */ });
/* unused harmony exports createImage, getRadianAngle, rotateSize, canvasToImage */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


var createImage = function(url) {
    return new Promise(function(resolve, reject) {
        var image = new Image();
        image.addEventListener("load", function() {
            return resolve(image);
        });
        image.addEventListener("error", function(error) {
            return reject(error);
        });
        image.setAttribute("crossOrigin", "anonymous");
        image.src = url;
    });
};
function getRadianAngle(degreeValue) {
    return degreeValue * Math.PI / 180;
}
function rotateSize(width, height, rotation) {
    var rotRad = getRadianAngle(rotation);
    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
    };
}
var canvasToImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(canvas) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        var dataUrl = canvas.toDataURL();
                        var image = new Image();
                        image.onload = function() {
                            resolve(image);
                        };
                        image.src = dataUrl;
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function canvasToImage(canvas) {
        return _ref.apply(this, arguments);
    };
}();
var canvasToBlob = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(canvas) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        canvas.toBlob(function(blob) {
                            resolve(blob);
                        }, "image/jpeg");
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function canvasToBlob(canvas) {
        return _ref.apply(this, arguments);
    };
}();
var getCroppedImg = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(imageSrc, pixelCrop) {
        var rotation, clampWidth, flip, image, canvas, ctx, rotRad, ref, bBoxWidth, bBoxHeight, data, croppedImage, scalar, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    rotation = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 0, clampWidth = _args.length > 3 ? _args[3] : void 0, flip = _args.length > 4 && _args[4] !== void 0 ? _args[4] : {
                        horizontal: false,
                        vertical: false
                    };
                    _ctx.next = 3;
                    return createImage(imageSrc);
                case 3:
                    image = _ctx.sent;
                    canvas = document.createElement("canvas");
                    ctx = canvas.getContext("2d");
                    if (ctx) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 8:
                    rotRad = getRadianAngle(rotation);
                    ref = rotateSize(image.width, image.height, rotation), bBoxWidth = ref.width, bBoxHeight = ref.height;
                    // set canvas size to match the bounding box
                    canvas.width = bBoxWidth;
                    canvas.height = bBoxHeight;
                    // translate canvas context to a central location to allow rotating and flipping around the center
                    ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
                    ctx.rotate(rotRad);
                    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
                    ctx.translate(-image.width / 2, -image.height / 2);
                    // draw rotated image
                    ctx.drawImage(image, 0, 0);
                    data = ctx.getImageData(pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height);
                    // set canvas width to final desired crop size - this will clear existing context
                    canvas.width = pixelCrop.width;
                    canvas.height = pixelCrop.height;
                    // paste generated rotate image at the top left corner
                    ctx.putImageData(data, 0, 0);
                    if (!(!clampWidth || pixelCrop.width <= clampWidth)) {
                        _ctx.next = 23;
                        break;
                    }
                    return _ctx.abrupt("return", canvasToBlob(canvas));
                case 23:
                    _ctx.next = 25;
                    return canvasToImage(canvas);
                case 25:
                    croppedImage = _ctx.sent;
                    scalar = clampWidth / pixelCrop.width;
                    canvas.width = clampWidth;
                    canvas.height = pixelCrop.height * scalar;
                    ctx.drawImage(croppedImage, 0, 0, canvas.width, canvas.height);
                    return _ctx.abrupt("return", canvasToBlob(canvas));
                case 31:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCroppedImg(imageSrc, pixelCrop) {
        return _ref.apply(this, arguments);
    };
}();
var isTransparentPNG = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        if (file.type !== "image/png") {
                            // false for non-pngs
                            resolve(false);
                            return;
                        }
                        // create image
                        var img = new Image();
                        img.onload = function() {
                            // create canvas
                            var canvas = document.createElement("canvas");
                            var ctx = canvas.getContext("2d");
                            // scaling to 300px width
                            var width = 300;
                            var scalar = width / img.width;
                            canvas.width = width;
                            canvas.height = img.height * scalar;
                            if (ctx) {
                                // draw image to canvas
                                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                                // look for transparency
                                var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
                                var hasAlphaPixel = false;
                                for(var i = 3; i < data.length; i += 4){
                                    if (data[i] < 255) {
                                        hasAlphaPixel = true;
                                        break;
                                    }
                                }
                                URL.revokeObjectURL(img.src);
                                resolve(hasAlphaPixel);
                            } else {
                                // fail silently if ctx is null
                                resolve(false);
                            }
                        };
                        img.src = URL.createObjectURL(file);
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function isTransparentPNG(file) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 49503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ testNodeHealth; }
/* harmony export */ });
/* unused harmony export testNodes */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _lib_beacon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91435);
/* harmony import */ var _state_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92089);
/* harmony import */ var _state_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80683);


/* eslint-disable @typescript-eslint/no-explicit-any */ 



var testNodes = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var before, result, ref, timestamp, nodes;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    before = Date.now();
                    _ctx.next = 3;
                    return fetch("https://status.versum.xyz/api/rpc");
                case 3:
                    result = _ctx.sent;
                    if (!(result.status === 200)) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.next = 7;
                    return result.json();
                case 7:
                    ref = _ctx.sent;
                    timestamp = ref.timestamp;
                    nodes = ref.nodes;
                    return _ctx.abrupt("return", {
                        response: Date.now() - before,
                        timestamp: timestamp,
                        nodes: nodes
                    });
                case 11:
                    return _ctx.abrupt("return", {
                        response: Date.now() - before,
                        timestamp: Date.now(),
                        nodes: []
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function testNodes() {
        return _ref.apply(this, arguments);
    };
}();
var testNodeHealth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var callback, store, state, ping, currentNode, curTry, maxTry, swapAndTestNode, healthyNode, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    callback = _args.length > 0 && _args[0] !== void 0 ? _args[0] : function() {
                        return null;
                    };
                    store = (0,_state_store__WEBPACK_IMPORTED_MODULE_4__/* .getStore */ .bh)();
                    state = store === null || store === void 0 ? void 0 : store.getState();
                    if (!(state.settings.general.nodetype === _constants__WEBPACK_IMPORTED_MODULE_1__/* .NODE_TYPE.AUTO */ .QZ.AUTO)) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 6;
                    return testNodes();
                case 6:
                    ping = _ctx.sent;
                    currentNode = ping.nodes.find(function(e) {
                        return "https://".concat(e.node) === state.settings.general.node;
                    });
                    curTry = 0;
                    maxTry = 10;
                    swapAndTestNode = function() {
                        // change to new node
                        (0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .setInitialRandomNode */ .k9)();
                        var nextNode = (0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getInitialRandomNode */ .hm)().value;
                        // check node from request
                        currentNode = ping.nodes.find(function(e) {
                            return "https://".concat(e.node) === nextNode;
                        });
                        if ((!currentNode || currentNode.level < 0 || currentNode.level > 2) && curTry < maxTry) {
                            curTry += 1;
                            swapAndTestNode();
                        }
                        // if node is valid, save preferences?
                        store === null || store === void 0 ? void 0 : store.dispatch({
                            type: _state_settings__WEBPACK_IMPORTED_MODULE_3__/* .actions.SETTINGS_CHANGE_NODE */ .Nw.SETTINGS_CHANGE_NODE,
                            payload: "https://".concat(currentNode.node)
                        });
                        (0,_lib_beacon__WEBPACK_IMPORTED_MODULE_2__/* .changeBeacon */ .sW)(state.settings.general.network, "https://".concat(currentNode.node));
                    };
                    healthyNode = currentNode.level >= 0 && currentNode.level <= 2;
                    if (!healthyNode) {
                        swapAndTestNode();
                    }
                case 13:
                    callback();
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function testNodeHealth() {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);